var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "match",
      style: {
        backgroundImage:
          "url(" +
          JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
            .match.background.pictureUrl +
          ")"
      }
    },
    [
      _c("div", { staticStyle: { height: "420px" } }),
      _c("div", {
        staticClass: "btn btn1",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .match.rulesBtn.pictureUrl +
            ")"
        }
      }),
      _c("div", {
        staticClass: "btn btn2",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .match.myPrize.pictureUrl +
            ")"
        }
      }),
      _c("div", {
        staticClass: "entry",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .match.matchChampion.pictureUrl +
            ")"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }